import { Component, OnInit } from '@angular/core';
import { IFilterFilters } from '../ifilter';
import { Datalistrequestfilter } from '../../request/datalistrequestfilter';
import { EnforcementService } from 'src/app/Services/enforcement.service';

@Component({
    selector: '[app-infringement-types-filter]',
    templateUrl: './infringement-types-filter.component.html',
    styleUrls: ['./infringement-types-filter.component.scss'],
    host: { 'class': 'control' },
    standalone: false
})
export class InfringementTypesFilterComponent implements OnInit, IFilterFilters {
  public InfringementTypes: any[] = [];
  public SelectedInfringementTypeId: string = "all";
  public FilterName: string = "infringementType";
  public Filters: Datalistrequestfilter[] = [];
  public QueryParamPrefix: string = '';
  public loading = false;

  constructor(private enforcementService: EnforcementService) {}

  async ngOnInit(): Promise<void> {
    this.loading = true;
    try {
      // Load all active infringement types
      const response: any = await this.enforcementService.searchInfringementTypes({
        PageSize: 100,
        PageIndex: 0,
        Subset: '',
        Search: '',
        Filters: [],
        OrderByProperty: 'Name',
        Ascending: true
      });
      
      if (response && response.Data) {
        this.InfringementTypes = response.Data;
      }
    } catch (error) {
      console.error('Failed to load infringement types for filter', error);
    } finally {
      this.loading = false;
    }
  }

  public addInfringementTypeFilter(event: any) {
    const val = event.target.value;
    this.Filters = [];

    if (val !== "" && val !== "all") {
      this.Filters.push({
        Property: "InfringementTypeId",
        Comparator: "==",
        Value: val,
        FilterName: this.FilterName
      });
      this.SelectedInfringementTypeId = val;
    } else {
      this.SelectedInfringementTypeId = "";
    }
  }
}

